import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import classnames from 'classnames';

import { IconWithDotBadge } from 'shared/components';

import theme from './AppointmentStatusBar.scss';


const propTypes = {
  attachments: PropTypes.array,
  permissions: PropTypes.shape({
    canSeeFiles: PropTypes.bool.isRequired,
  }).isRequired,

  filePrerequisiteStatus: PropTypes.string,
  filesPrerequisitesConfig: PropTypes.object,
  closeTime: PropTypes.string,
  casePrerequisitesConfig: PropTypes.object,
};

const defaultProps = {
  attachments: [],
  closeTime: undefined,
  filePrerequisiteStatus: null,
  filesPrerequisitesConfig: null,
  casePrerequisitesConfig: null,
};

const AppointmentStatusBar = ({
  closeTime,
  attachments,
  permissions,
  filePrerequisiteStatus,
  filesPrerequisitesConfig,
  casePrerequisitesConfig,
}) => (
  <div className={ theme.root }>
    <If condition={ attachments && attachments.length > 0 && permissions.canSeeFiles }>
      <IconWithDotBadge
        inverted
        name="attachment"
      />
    </If>
    <If condition={ filesPrerequisitesConfig && filesPrerequisitesConfig.enabled && filePrerequisiteStatus === 'INCOMPLETE' }>
      <div className={ theme.missingFiles }>
        <IconWithDotBadge
          color="mediumRed"
          iconWidth="13px"
          iconFontSize="13px"
          name="exclamation_outline"
          withoutBackground
        />
        <div className={ !closeTime && theme.missingFilesTitle }>
          <FormattedMessage
            id="Service.AppointmentPrerequisites.UploadedFiles.MinUploadedFilesModel.AppointmentCardNotification.Label"
            defaultMessage="Missing Files"
          />
        </div>
      </div>
    </If>
    <If condition={ casePrerequisitesConfig && casePrerequisitesConfig.status === 'INCOMPLETE' && casePrerequisitesConfig.errorMessage }>
      <div className={ classnames(theme.missingFiles, theme.missingCase) }>
        <IconWithDotBadge
          color="mediumRed"
          iconWidth="13px"
          iconFontSize="13px"
          name="exclamation_outline"
          withoutBackground
        />
        <div className={ !closeTime && theme.missingCaseDataTitle }>
          { casePrerequisitesConfig.errorMessage }
        </div>
      </div>
    </If>
  </div>
);

AppointmentStatusBar.propTypes = propTypes;
AppointmentStatusBar.defaultProps = defaultProps;

export default AppointmentStatusBar;
